<template>
  <div
    class="text"
    :class="{'show-border-top': !file }"
  >
    <VProgressLinear
      v-if="sending"
      :indeterminate="true"
      style="margin: 0px"
    />
    <!-- file container -->
    <div
      v-if="file"
      class="file-container"
    >
      <VLayout
        row
        wrap
      >
        <VFlex
          xs9
        >
          <VLayout
            row
            justify-start
            align-center
            fill-height
          >
            <span class="icon-file-message">
              <img
                src="@/assets/file.svg"
                alt="genericFileIcon"
                height="15"
              >
            </span>
            {{ file.name }}
          </VLayout>
        </VFlex>
        <VFlex
          xs3
        >
          <VLayout
            row
            justify-end
          >
            <VBtn
              dark
              small
              icon
              style="margin: 0px"
              @click.prevent="onCancelFile"
            >
              <VIcon>
                close
              </VIcon>
            </VBtn>
          </VLayout>
        </VFlex>
      </VLayout>
    </div>
    <form
      class="sc-user-input"
      :class="{active: inputActive}"
    >
      <div
        ref="userInput"
        role="button"
        tabIndex="0"
        contentEditable="true"
        :placeholder="placeholder"
        class="sc-user-input--text"
        @focus.prevent="setInputSelected(true)"
        @blur.prevent="setInputSelected(false)"
        @keypress="handleKey"
      />
      <div class="sc-user-input--buttons">
        <div
          v-if="showFile"
          class="sc-user-input--button"
        >
          <VBtn
            small
            icon
            :disabled="sending"
            style="margin: 0px"
          >
            <VIcon>
              attach_file
            </VIcon>
            <input
              id="file-input"
              type="file"
              @change="onFileChanged"
              @click="onAttachFileClicked"
            >
          </VBtn>
        </div>
        <div class="sc-user-input--button">
          <VBtn
            small
            icon
            style="margin: 0px"
            :disabled="sending"
            @click.prevent="submitText"
          >
            <VIcon>
              send
            </VIcon>
          </VBtn>
        </div>
      </div>
    </form>
    <ProgressDialogCard
      :description="progressDialogDescription"
      :dialog="uploadingFile"
      indeterminate
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProgressDialogCard from '@/components/ProgressDialogCard'
export default {
  name: 'TextBox',
  components: { ProgressDialogCard },
  props: {
    placeholder: {
      type: String,
      default: 'press Shift + Enter for a new line'
    },
    showFile: {
      type: Boolean,
      default: () => false
    },
    submitText: {
      type: Function,
      default: function () {
        if (this.sending) return
        if (this.file) {
          // can submit MMS without header
          this.sendMMS({ msgBody: this.$refs.userInput.textContent, file: this.file, contact: this.contact })
        } else {
          const text = this.$refs.userInput.textContent.replace(/\s/g, '')
          if (text && text.length > 0) {
            this.sendMessage({ msgBody: this.$refs.userInput.textContent, contact: this.contact })
            this.$refs.userInput.innerHTML = ''
          }
        }
      }
    },
    sending: {
      type: Boolean,
      default: false
    },
    uploadingFile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      inputSelected: false,
      file: null,
      progressDialogDescription: 'Uploading the files'
    }
  },
  computed: {
    ...mapGetters({
      contact: 'messageDrawer/getItem'
    }),
    inputActive () {
      return !this.sending && (this.inputSelected)
    }
  },
  watch: {
    sending: function () {
      if (!this.sending && this.file) {
        this.file = null
      }
    }
  },
  methods: {
    ...mapActions({
      sendMessage: 'message/sendMessage',
      sendMMS: 'message/sendMMS'
    }),
    onCancelFile () {
      this.file = null
    },
    setInputSelected (value) {
      this.inputSelected = value
    },
    setAttachBtnSelected (value) {
      this.attachBtnSelected = value
    },
    setSubmitBtnSelected (value) {
      this.submitBtnSelected = value
    },
    handleKey (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        this.submitText(e)
        e.preventDefault()
        return false
      } else if (e.shiftKey && e.key === 'Enter') {}
    },
    onFileChanged (e) {
      this.file = e.target.files[0]
    },
    onAttachFileClicked (e) {
      e.target.value = null
    }
  }
}
</script>

<style lang="less" scoped>
  .text {
    textarea {
      padding: 10px;
      height: 100%;
      width: 100%;
      border: none;
      outline: none;
      font-family: "Micrsofot Yahei";
      resize: none;
      overflow-y: scroll;
    }
  }
  .show-border-top {
    border-top: solid 1px #ddd;
  }
  .file-container {
    color: #f4f7f9;
    border-top-left-radius: 10px;
    padding: 5px 20px;
    background-color: #565867;
  }
  .delete-file-message {
    font-style: normal;
    color: #c8cad0;
    .icon {
      fill: white;
    }
  }
  .sc-user-input {
    min-height: 55px;
    margin: 0px;
    position: relative;
    bottom: 0;
    display: flex;
    background-color: #f4f7f9;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transition: background-color 0.2s ease, box-shadow 0.2s ease;
  }
  .sc-user-input--text {
    width: 85%;
    resize: none;
    border: none;
    outline: none;
    border-bottom-left-radius: 10px;
    box-sizing: border-box;
    padding: 18px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.33;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: #565867;
    -webkit-font-smoothing: antialiased;
    max-height: 200px;
    overflow: scroll;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .sc-user-input--text:empty:before {
    content: attr(placeholder);
    display: block; /* For Firefox */
    /* color: rgba(86, 88, 103, 0.3); */
    filter: contrast(15%);
    outline: none;
  }
  .sc-user-input--buttons {
    width: 60px;
    position: absolute;
    right: 5px;
    height: 100%;
    display: flex;
  }
  .sc-user-input--button:first-of-type {
    width: 30px;
  }
  .sc-user-input--button {
    width: 30px;
    height: 55px;
    margin-left: 2px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
  }
  .sc-user-input.active {
    box-shadow: none;
    background-color: white;
    box-shadow: 0px -5px 20px 0px rgba(150, 165, 190, 0.2);
  }
  .sc-user-input--button input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
  }
</style>
